module.exports = __webpack_public_path__ + "static/media/USDT.ce81e6df.svg";